import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex; 
  flex-direction: column; 
  margin-bottom: 20px;
`;

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const DocumentWrapper = styled.div`
  margin-right: 20px;
`;



// WEBPACK FOOTER //
// ./src/containers/scalable-document-list/styles.ts